<template>
  <div class="header">
    <img class="header__image" src="@/assets/images/styling.jpg" />
    <div>
      <h4 class="heading">How to style it</h4>
      <p class="sub-heading">Styling notes by our Creative Directors</p>
      <p class="sub-heading">Valentina & Stephanie</p>
    </div>
  </div>
  <div class="wysiwyg">
    <p v-for="(paragraph, index) in stylingDescription" :key="index">
      {{ paragraph }}
    </p>
  </div>
</template>

<script>
import productIdQuery from "@/graphql/queries/ProductId.gql";
import { unwrapNodes } from "@/helpers/graphql";
import { mapState } from "vuex";

export default {
  name: "Styling",
  data() {
    return {
      products: [],
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    stylingImages() {
      return unwrapNodes(this.product.stylingImages?.references?.edges) || [];
    },
    stylingDescription() {
      const str = this.product.stylingDescription.value;
      const paragraphs = str.split(/\r?\n/);
      return paragraphs;
    },
  },
  async created() {
    const groupedProductIds = await this.fetchGroupedProductIds();
    await this.getProducts(groupedProductIds);
  },
  methods: {
    async fetchGroupedProductIds() {
      const productID = this.product.id.split("gid://shopify/Product/")[1];

      if (!productID) {
        return;
      }

      const url = `${process.env.PRODUCT_GROUPING_GADGET_URL}/grouped-products/${productID}`;

      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!resp.ok) {
        throw new Error("Error fetching grouped products");
      }

      const data = await resp.json();

      return data?.products || [];
    },
    async getProducts(products) {
      const promises = products.map(({ id }) => {
        return this.$apollo.query({
          query: productIdQuery,
          variables: {
            productId: "gid://shopify/Product/" + id,
          },
        });
      });

      const values = await Promise.all(promises);
      values.forEach((value) => {
        const product = value.data.product;

        const order = products.find(
          (p) => "gid://shopify/Product/" + p.id === product.id
        ).order;

        this.products.push({ ...product, order });
      });
    },
  },
};
</script>

<styling lang="scss" scoped>
.header {
  display: flex;
  gap: 20px;
  align-content: center;
  margin: 0 0 24px;
  &__image {
    width: 80px;
  }
}
.heading {
  @include utility-label(14px);

  @include respond-above(md) {
    font-size: 20px;
  }
}

.sub-heading {
  @include utility-body(14px);
  color: $color-grey-dark;
}
.styling-images {
  display: flex;
  overflow-x: auto;
  flex-flow: row nowrap;
  gap: 2px;
  margin-bottom: 10px;

  & > * {
    flex: 1 0 auto;
  }
}

.wysiwyg {
  margin-bottom: 24px;
}

.wysiwyg p {
  @include editorial-body(16px);

  @include respond-above(md) {
    font-size: 20px;
  }
}

.product-carousel.carousel-wrapper {
  margin: 0 -20px;
  @include respond-above(md) {
    margin: 0;
  }
}
</styling>
